<template>
  <div>
    <!-- type 1 上下结构 2 左右结构 -->
    <div class="news_item" v-if="type == 1" @click="toDetails(newsData)">
      <div class="news_imgwrap">
        <img
          class="news_img"
          v-if="newsData.thumb"
          :src="newsData.thumb"
          alt=""
        />
        <img class="news_img" v-else src="../assets/kv.jpg" alt="" />
      </div>
      <div class="news_main">
        <div class="news_title color">
          {{
            langSet == "cn"
              ? newsData.title
              : newsData.en_title
              ? newsData.en_title
              : newsData.title
          }}
        </div>
        <!-- <div class="news_con">
          {{ langSet == "cn" ? newsData.desc : newsData.en_desc }}
        </div> -->
        <div class="news_more flex flex_items_center flex_content_sb">
          <span>{{ newsData._inputtime }}</span>
          <span class="more">{{ langSet == "cn" ? "详情" : "Details" }}</span>
        </div>
      </div>
    </div>

    <div
      class="news_item news_type flex"
      v-if="type == 2"
      @click="toDetails(newsData)"
    >
      <div class="news_imgwrap">
        <img
          class="news_img"
          v-if="newsData.thumb"
          :src="newsData.thumb"
          alt=""
        />
        <img class="news_img" v-else src="../assets/kv.jpg" alt="" />
      </div>
      <div class="news_main">
        <div class="news_title color fb">
          {{ langSet == "cn" ? newsData.title : newsData.en_title }}
        </div>
        <div class="time">{{ newsData._inputtime }}</div>
        <div class="news_con">
          {{ langSet == "cn" ? newsData.desc : newsData.en_desc }}
        </div>
        <div class="news_more flex flex_items_center flex_content_end color">
          {{ langSet == "cn" ? "查看详情" : "Details" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sdkClick } from "../sdk/useSdk";
export default {
  props: {
    type: Number,
    newsData: Object,
  },
  data() {
    return {
      langSet: "",
    };
  },
  created() {},
  mounted() {
    this.langSet = this.$language;
  },
  methods: {
    //25.9.16 跳转详情 dxm
    toDetails(e) {
      sdkClick("新闻资讯", e.title);
      if (e.http_type == "1") {
        this.$router.push({
          path: "/newsDetails",
          query: {
            id: e.id,
          },
        });
      } else {
        window.open(
          this.langSet == "cn"
            ? e.http_url
            : e.http_url_en
            ? e.http_url_en
            : e.http_url,
          "_blank"
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.news_item {
  color: #555;
  cursor: pointer;
  font-size: 18px;
  line-height: 28px;
  padding: 10px;
  background: #f9f9f9;
  border-radius: 20px;
  transition: all 0.2s;
  position: relative;
  top: 0;
  box-sizing: border-box;
  .more {
    width: 68px;
    height: 28px;
    font-size: 14px;
    line-height: 28px;
    text-align: center;
    box-sizing: border-box;
  }
  &:hover {
    top: -10px;
    box-shadow: 0px 10px 38px 0px rgba(29, 35, 121, 0.12);
    .more {
      color: #fff;
      background: #1d2379;
      border-radius: 15px;
    }
  }
  .news_imgwrap {
    width: 100%;
    height: 200px;
    overflow: hidden;
    border-radius: 20px;
    .news_img {
      width: 100%;
      height: 100%;
    }
  }

  .news_main {
    margin-top: 20px;
  }
  .news_title {
    color: #001a33;
    font-size: 20px;
    height: 60px;
    margin-bottom: 15px;
    line-height: 30px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .news_con {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
  }
  .news_more {
    font-size: 14px;
    color: #44435a;
    line-height: 20px;
    padding-bottom: 20px;
  }
}
.news_type {
  margin-top: 40px;
  .news_imgwrap {
    width: 290px;
    height: 200px;
    border-radius: 0;
  }
  .news_main {
    flex: 1;
    padding-left: 20px;
    margin-top: 10px;
    .news_title {
      font-weight: 500;
    }
    .news_con {
      margin-top: 10px;
    }
    .news_more {
      margin-top: 28px;
    }
  }
}
@media only screen and (max-width: 767px) {
  .news_item {
    font-size: 0.29rem;
    line-height: 0.4rem;
    display: flex;
    border-radius: 16px;
    .news_imgwrap {
      width: 2.79rem;
      height: 1.92rem;
      border-radius: 0.15rem;
    }
    .news_main {
      margin-top: 0;
      flex: 1;
      margin-left: 0.19rem;
    }
    .news_title {
      color: #000;
      height: 48px;
      font-size: 0.29rem;
      margin-bottom: 0.19rem;
      line-height: 0.46rem;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* 限制文本显示为3行，超出部分显示省略号 */
      overflow: hidden;
    }
    .news_con {
      display: none;
    }
    .news_more {
      color: #44435a;
      margin-top: 0;
      padding-bottom: 0;
      .more {
        display: none;
      }
      img {
        width: 0.31rem;
        height: 0.31rem;
      }
    }
  }
  .news_type {
    margin-top: 0.38rem;
    .news_imgwrap {
      width: 2.79rem;
      height: 1.92rem;
      // border-radius: 0.15rem;
    }
    .news_main {
      flex: 1;
      margin-left: 0.19rem;
      padding-left: 0;
      margin-top: 0;
      .news_title {
        font-size: 0.31rem;
        line-height: 0.46rem;
        font-weight: 500;
      }
      .news_con {
        margin-top: 10px;
      }
      .time {
        display: none;
      }
      .news_more {
        margin-top: 9px;
        justify-content: flex-start;
      }
    }
  }
}
</style>